import { render, staticRenderFns } from "./besonderheiten-base.vue?vue&type=template&id=587a85a2"
import script from "./besonderheiten-base.vue?vue&type=script&lang=js"
export * from "./besonderheiten-base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports